<template>
  <!--
        作者：gmshop
        时间：2020-06-08
        描述：超链接选择-营销
    -->
  <div class="marketing-box">
    <el-tabs v-model="activeTab">
      <el-tab-pane v-if="show_signin" label="签到" name="signin"></el-tab-pane>
      <el-tab-pane v-if="show_points" label="积分商城" name="points"></el-tab-pane>
      <el-tab-pane v-if="show_seckill" label="秒杀" name="seckill"></el-tab-pane>
      <el-tab-pane v-if="show_assemble" label="拼团" name="assemble"></el-tab-pane>
      <el-tab-pane v-if="show_bargain" label="砍价" name="bargain"></el-tab-pane>
      <el-tab-pane v-if="show_package"  label="礼包购" name="package"></el-tab-pane>
      <el-tab-pane v-if="show_invitation"  label="邀请有礼" name="invitation"></el-tab-pane>
      <el-tab-pane v-if="show_coupon"  label="优惠券" name="coupon"></el-tab-pane>
      <el-tab-pane v-if="show_sweepstakes"  label="积分抽奖" name="sweepstakes"></el-tab-pane>
    </el-tabs>
    <el-select v-model="activePage" placeholder="请选择" class="percent-w100" @change="changeFunc" value-key="id">
      <el-option v-for="(item, index) in pages" :key="index" :label="item.name" :value="item"></el-option>
    </el-select>
  </div>
</template>

<script>
  import LinkApi from '@/api/link.js';
  export default {
    data() {
      return {
        show_points:true,
        show_seckill:true,
        show_assemble:true,
        show_bargain:true,
        show_package:true,
        show_invitation:true,
        show_coupon:true,
        show_signin:true,
        show_sweepstakes:true,
        /*tab切换选择中值*/
        activeTab: '',
        /*页面数据*/
        pages: [],
        /*选中的值*/
        activePage: null,
        /*秒杀数据*/
        seckillList: [{
          id: 0,
          url: 'pages/plus/seckill/list/list',
          name: '秒杀',
          type: '营销'
        }],
        /*签到数据*/
        signinList: [{
          id: 0,
          url: 'pages/plus/signin/signin',
          name: '签到',
          type: '营销'
        }],
        /*积分商城数据*/
        pointsList: [{
          id: 0,
          url: 'pages/plus/points/list/list',
          name: '积分商城',
          type: '营销'
        }],
        /*拼团*/
        assembleList: [{
          id: 0,
          url: 'pages/plus/assemble/list/list',
          name: '拼团',
          type: '营销'
        }],
        /*砍价*/
        bargainList: [{
          id: 0,
          url: 'pages/plus/bargain/list/list',
          name: '砍价',
          type: '营销'
        }],
        /*领券中心*/
        couponList: [{
          id: 0,
          url: 'pages/coupon/coupon',
          name: '领券中心',
          type: '营销'
        }],
        /*积分抽奖*/
        sweepstakesList: [{
          id: 0,
          url: 'application/luckDraw/index',
          name: '积分抽奖',
          type: '营销'
        }],
        // 礼包购活动
        packageList: [],
        // 邀请有礼活动
        invitationList: []
      };
    },
    watch: {
      activeTab: function(n, o) {
        let self = this;
        self.pages = [];
        if (n != o) {
          if (n == 'signin') {
            self.pages = self.signinList;
          } else if (n == 'points') {
            self.pages = self.pointsList;
          } else if (n == 'seckill') {
            self.pages = self.seckillList;
          } else if (n == 'assemble') {
            self.pages = self.assembleList;
          } else if (n == 'bargain') {
            self.pages = self.bargainList;
          } else if (n == 'package') {
            self.pages = self.packageList;
          } else if (n == 'invitation') {
            self.pages = self.invitationList;
          }else if (n == 'coupon') {
            self.pages = self.couponList;
          }else if (n == 'sweepstakes') {
            self.pages = self.sweepstakesList;
          }
          self.autoSend();
        }
      }
    },
    created() {
      this.pages = this.signinList;
      this.int();
      this.autoSend();
      this.getData();
    },
    methods: {
      // 检测权限
      int(){
        if(!this.$filter.isAuth('/plus/assemble/active/index')) this.show_assemble = false;
        if(!this.$filter.isAuth('/plus/bargain/active/index')) this.show_bargain = false;
        if(!this.$filter.isAuth('/plus/seckill/active/index')) this.show_seckill = false;
        if(!this.$filter.isAuth('/plus/points/product/index')) this.show_points = false;
        if(!this.$filter.isAuth('/plus/package/index')) this.show_package = false;
        if(!this.$filter.isAuth('/plus/invitation/active/lists')) this.show_invitation = false;
        if(!this.$filter.isAuth('/plus/coupon/coupon/index')) this.show_coupon = false;
        if(!this.$filter.isAuth('/plus/sign/index')) this.show_signin = false;
        if(!this.$filter.isAuth('/plus/sweepstakes/sweepstakes/index')) this.show_sweepstakes = false;
      },
      /*获取数据*/
      getData() {
        let self = this;
        LinkApi.getList({},true)
          .then(res => {
            self.packageList = res.data.packageList;
            self.invitationList = res.data.invitationList;
          })
          .catch(error => {});
      },
      /*自动发送*/
      autoSend() {
        if (this.pages.length > 0) {
          this.activePage = this.pages[0];
          this.changeFunc();
        }
      },
      /*选中的值*/
      changeFunc(e) {
        this.$emit('changeData', this.activePage);
      },
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/setlink/part/Marketing.vue